import { TourStep } from "../tour/Tour";

/** localStorage key suffix for the once-per-user auto-open. */
export const INTAKE_TOUR_KEY = "guided-intake";

// data-tour-id anchors, applied where each element renders.
export const INTAKE_TOUR_CHAT_ID = "intake-chat";
export const INTAKE_TOUR_NAME_ID = "intake-project-name";
export const INTAKE_TOUR_NAV_ID = "intake-nav";
export const INTAKE_TOUR_DOCUMENTS_ID = "intake-documents";
export const INTAKE_TOUR_CONTEXT_ID = "intake-context";
export const INTAKE_TOUR_SUBMIT_ID = "intake-submit";

export const INTAKE_TOUR_STEPS: TourStep[] = [
    {
        title: "Welcome to Guided Intake",
        text: "This is the new way to request an analysis: pick what you need, add your documents, and answer a few questions along the way. Here's a quick look around. It takes less than a minute.",
    },
    {
        title: "Everything starts here",
        text: "The assistant walks you through step by step: choose the analysis you need, upload your documents, then fill in the rest by chatting or answering guided questions, whichever you prefer.",
        anchorId: INTAKE_TOUR_CHAT_ID,
    },
    {
        title: "Name your project",
        text: "We suggest a name as we learn about your project. Click it any time to rename.",
        anchorId: INTAKE_TOUR_NAME_ID,
    },
    {
        title: "Change your mind anytime",
        text: "Use Back to revisit an earlier step, or Start over to delete the draft and begin again from scratch.",
        anchorId: INTAKE_TOUR_NAV_ID,
    },
    {
        title: "Your documents",
        text: "Everything you upload is listed here. Use Add to attach more at any point, or simply drop files anywhere in this window.",
        anchorId: INTAKE_TOUR_DOCUMENTS_ID,
    },
    {
        title: "What the analysis needs",
        text: "This checklist tracks the context that makes your analysis better. Items tick off automatically as you make choices, upload documents, and answer questions.",
        anchorId: INTAKE_TOUR_CONTEXT_ID,
    },
    {
        title: "Request your analysis",
        text: "When you're done, send everything to our analysts here. If a recommended input is still missing, we'll point it out first, and you can always submit anyway.",
        anchorId: INTAKE_TOUR_SUBMIT_ID,
    },
];
